export enum ActionTypes {
  FETCH_COMPLETIONS_VS_SENDS_METRICS_REQUEST = 'goals/FETCH_COMPLETIONS_VS_SENDS_METRICS_REQUEST',
  FETCH_COMPLETIONS_VS_SENDS_METRICS_RESPONSE = 'goals/FETCH_COMPLETIONS_VS_SENDS_METRICS_RESPONSE',
  FETCH_COMPLETIONS_VS_SENDS_METRICS_ERROR = 'goals/FETCH_COMPLETIONS_VS_SENDS_METRICS_ERROR',
  FETCH_CONVERSION_EVENTS_VS_SENDS_REQUEST = 'goals/FETCH_CONVERSION_EVENTS_VS_SENDS_REQUEST',
  FETCH_CONVERSION_EVENTS_VS_SENDS_RESPONSE = 'goals/FETCH_CONVERSION_EVENTS_VS_SENDS_RESPONSE',
  FETCH_CONVERSION_EVENTS_VS_SENDS_ERROR = 'goals/FETCH_CONVERSION_EVENTS_VS_SENDS_ERROR',
  FETCH_GOAL_PERFORMANCE_REQUEST = 'goals/FETCH_GOAL_PERFORMANCE_REQUEST',
  FETCH_GOAL_PERFORMANCE_RESPONSE = 'goals/FETCH_GOAL_PERFORMANCE_ERROR_RESPONSE',
  FETCH_GOAL_PERFORMANCE_ERROR = 'goals/FETCH_GOAL_PERFORMANCE_ERROR',
  FETCH_PERFORMANT_CAMPAIGNS_REQUEST = 'goals/FETCH_PERFORMANT_CAMPAIGNS_REQUEST',
  FETCH_PERFORMANT_CAMPAIGNS_RESPONSE = 'goals/FETCH_PERFORMANT_CAMPAIGNS_RESPONSE',
  FETCH_PERFORMANT_CAMPAIGNS_ERROR = 'goals/FETCH_PERFORMANT_CAMPAIGNS_ERROR',
  FETCH_CONTRIBUTIONS_BY_MEDIUM_REQUEST = 'goals/FETCH_CONTRIBUTIONS_BY_MEDIUM_REQUEST',
  FETCH_CONTRIBUTIONS_BY_MEDIUM_RESPONSE = 'goals/FETCH_CONTRIBUTIONS_BY_MEDIUM_RESPONSE',
  FETCH_CONTRIBUTIONS_BY_MEDIUM_ERROR = 'goals/FETCH_CONTRIBUTIONS_BY_MEDIUM_ERROR',
  FETCH_GOAL_ANALYTICS_REQUEST = 'goals/FETCH_GOAL_ANALYTICS_REQUEST',
  FETCH_GOAL_ANALYTICS_RESPONSE = 'goals/FETCH_GOAL_ANALYTICS_RESPONSE',
  FETCH_GOAL_ANALYTICS_ERROR = 'goals/FETCH_GOAL_ANALYTICS_ERROR',
  FETCH_CAMPAIGN_CONTRIBUTIONS_REQUEST = 'goals/FETCH_CAMPAIGN_CONTRIBUTIONS_REQUEST',
  FETCH_CAMPAIGN_CONTRIBUTIONS_RESPONSE = 'goals/FETCH_CAMPAIGN_CONTRIBUTIONS_RESPONSE',
  FETCH_CAMPAIGN_CONTRIBUTIONS_ERROR = 'goals/FETCH_CAMPAIGN_CONTRIBUTIONS_ERROR',
  SET_CAMPAIGN_CONTRIBUTION_PAGINATION = 'goals/SET_CAMPAIGN_CONTRIBUTION_PAGINATION',
  SET_CAMPAIGN_CONTRIBUTION_SORT = 'goals/SET_CAMPAIGN_CONTRIBUTION_SORT',
}
